import React from "react";

export default function Header() {
  return (
    <header className="carrier-directory-header">
      <div className="title">
        <p className="welcome">Welcome to</p>
        <h1>Carrier Directory</h1>
        <p>
          The best online resource to find a carrier and logistics services.
          <br />
          Made to help companies find the best solution for their businesses
          and provide the visibility to the carriers.
        </p>
      </div>
    </header>
  );
}
